import { useSelector } from "react-redux";
import { useGetGoals } from "../../../../../hooks/api/queries/usePerformance";
import { useUrlSearch } from "../../../../../hooks/useUrlSearch";
import { goalsStatus } from "../../../../../localdata/goalsStatus";
import { useEffect, useState } from "react";

export const useAllGoals = () => {
  const {
    search,
    queries,
    filterByKey,
    gotoPage,
    filterBySearch,
    filterByDate,
  } = useUrlSearch();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { data, isLoading: isLoadingGoals } = useGetGoals({ queries });
  const [isGoalsForm, setIsGoalsForm] = useState(false);

  useEffect(() => {
    if (!search.get("status")) filterByKey("status", "active");
  }, []);

  return {
    search,
    goalsStatus,
    goalsList: data?.data,
    metaDetails: data?.meta,
    isLoadingGoals,
    storeList,
    isGoalsForm,
    setIsGoalsForm,
    filterByKey,
    gotoPage,
    filterBySearch,
    filterByDate,
  };
};
